import { render, staticRenderFns } from "./TrainingParametersForm.vue?vue&type=template&id=3b346d52&"
import script from "./TrainingParametersForm.vue?vue&type=script&lang=js&"
export * from "./TrainingParametersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports